import { defineModule } from '@core/index';
import { ModuleScope } from '@core/types';
import { ILSLogoFull } from './full';

export default defineModule({
  title: 'Логотип',
  component: ILSLogoFull,
  inScope: [ModuleScope.Logo, ModuleScope.HeaderLeft]
});
